// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trend-chart.chart-container {
  min-width: 280px;
}
.trend-chart.chart-container .highcharts-container {
  margin: 0 auto;
}
.trend-chart.chart-container .highcharts-container .highcharts-legend-item span {
  font-size: 14px;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/dashboardContainer/src/panels/TrendChart.vue","webpack://./TrendChart.vue"],"names":[],"mappings":"AACA;EACE,gBAAA;ACAF;ADCE;EACE,cAAA;ACCJ;ADAI;EACE,eAAA;EACA,0BAAA;ACEN","sourcesContent":["\n.trend-chart.chart-container {\n  min-width: 280px;\n  .highcharts-container {\n    margin: 0 auto;\n    .highcharts-legend-item span {\n      font-size: 14px;\n      text-transform: capitalize;\n    }\n    .highcharts-series {\n      //cursor: pointer;\n    }\n  }\n}\n",".trend-chart.chart-container {\n  min-width: 280px;\n}\n.trend-chart.chart-container .highcharts-container {\n  margin: 0 auto;\n}\n.trend-chart.chart-container .highcharts-container .highcharts-legend-item span {\n  font-size: 14px;\n  text-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
